import { useState, useEffect } from 'react'
import { Box, Grid, TextField, Typography } from '@mui/material'

function EmergencyContact ({ onValidationChange, showErrors, formData, onFormDataChange }) {
  const [errors, setErrors] = useState({})

  const handleChange = (e) => {
    const { name, value } = e.target
    onFormDataChange({ [name]: value })
  }

  useEffect(() => {
    const newErrors = {}
    if (!formData.emergencyFirstName?.trim()) newErrors.emergencyFirstName = 'First name is required.'
    if (!formData.emergencySurname?.trim()) newErrors.emergencySurname = 'Surname is required.'
    if (!formData.emergencyMobileNumber?.trim() || isNaN(formData.emergencyMobileNumber.replace(/[-+\s+()]/g, ''))) {
      newErrors.emergencyMobileNumber = 'Valid mobile number is required.'
    }
    setErrors(newErrors)
    onValidationChange(Object.keys(newErrors).length === 0)
  }, [formData, onValidationChange])

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant='h6'>Emergency Contact Details</Typography>

      <Grid container spacing={2} mt={2}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            label='First Name'
            name='emergencyFirstName'
            variant='outlined'
            value={formData.emergencyFirstName || ''}
            onChange={handleChange}
            error={showErrors && !!errors.emergencyFirstName}
            helperText={showErrors && errors.emergencyFirstName}
            required
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            label='Surname'
            name='emergencySurname'
            variant='outlined'
            value={formData.emergencySurname || ''}
            onChange={handleChange}
            error={showErrors && !!errors.emergencySurname}
            helperText={showErrors && errors.emergencySurname}
            required
          />
        </Grid>

        <Grid size={{ xs: 12 }}>
          <TextField
            fullWidth
            label='Relationship'
            name='emergencyRelationship'
            variant='outlined'
            value={formData.emergencyRelationship || ''}
            onChange={handleChange}
            error={showErrors && !!errors.emergencyRelationship}
            helperText={showErrors && errors.emergencyRelationship}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            label='Mobile Number'
            name='emergencyMobileNumber'
            variant='outlined'
            value={formData.emergencyMobileNumber || ''}
            onChange={handleChange}
            error={showErrors && !!errors.emergencyMobileNumber}
            helperText={showErrors && errors.emergencyMobileNumber}
            required
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            label='Alternative Contact Number'
            name='alternativeContactNumber'
            variant='outlined'
            value={formData.alternativeContactNumber || ''}
            onChange={handleChange}
          />
        </Grid>
      </Grid>
    </Box>
  )
}

export default EmergencyContact
